import axios from 'axios';
import apiConfig from '../../api.config';

export default async function invoiceGetDocumentTemplate(hotelId, chainId, lang) {
  const {
    host,
    URIs: { invoiceGetDocumentTemplate },
  } = apiConfig;

  const uri = `${host}${invoiceGetDocumentTemplate}`
    .replace(':chainId', chainId)
    .replace(':hotelId', hotelId)
    .replace(':lang', lang);

  return await axios.get(uri).then(res => res.data);
}
